/**
 * 現在のルートの自己参照 canonical を <head> に注入する。
 *
 * クエリパラメータ（?q= / ?tags= 等のフィルタ状態）とハッシュは canonical に含めない。
 * noindex を宣言するページ（404 等）では検索エンジンが canonical を無視するため、
 * 全ルート共通で配置してよい。
 */

import { useHead } from "@unhead/react";
import { useLocation } from "react-router-dom";
import { CANONICAL_BASE_URL } from "../../lib/constants";

export function CanonicalLink() {
  const { pathname } = useLocation();

  useHead({
    link: [{ rel: "canonical", href: `${CANONICAL_BASE_URL}${pathname}` }],
  });

  return null;
}
